import { loader } from "./scripts/loader";

export function init_funds_validator() {
    $(document).on("click", ".funds-validator-start", function (e) {
        e.preventDefault();

        try {
            $.ajax({
                url: window.glob_obj.ajaxurl,
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'funds_verification_student_start',
                    _ajax_nonce: window.std_data.funds_verification_student_start_nonce,
                },
                beforeSend: function () {
                    loader.show()
                },
                success: function (response) {
                    loader.hide();
                    location.href = window.location.pathname;
                },
                error: function (error) {
                    loader.hide();
                    console.log(error);
                }
            });
        } catch (error) {
            console.log(error);
            return;
        }
    });

    $(document).on('click', '#funds-verification-student-fee-start', function () {
        $(this).hide();
        $('#stripe-form').show();

        const uuid = $('#stripe-form').data('stripe-uuid');

        let elements;
        try {
            const stripe = Stripe(window.glob_obj.stripe_public_key);
            $.ajax({
                url: window.glob_obj.ajaxurl,
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'funds_verification_student_stripe_create_payment',
                    _ajax_nonce: window.std_data.funds_verification_student_stripe_create_payment_nonce,
                    uuid: uuid,
                },
                beforeSend: function () {
                    loader.show()
                },
                success: function (response) {
                    loader.hide();
                    const clientSecret = response.clientSecret;
                    elements = stripe.elements({ clientSecret });

                    const paymentElementOptions = {
                        layout: "tabs",
                    };

                    const paymentElement = elements.create("payment", paymentElementOptions);
                    paymentElement.mount('#stripe-form[data-stripe-uuid="' + uuid + '"] .stripe_payment_element');
                },
                error: function (error) {
                    loader.hide();
                    console.log(error);
                }
            });

            $(document).on('click', '.form_pay_button', function (e) {
                e.preventDefault();
                stripe_handle_submit(stripe, elements, uuid);
            });
        } catch (error) {
            console.log(error);
            return;
        }
    });

    $(document).on('click', '#funds-verification-fee-override', function () {
        const uuid = $('#stripe-form').data('stripe-uuid');
        try {
            $.ajax({
                url: window.glob_obj.ajaxurl,
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'funds_verification_student_stripe_override_payment',
                    _ajax_nonce: window.std_data.funds_verification_student_stripe_override_payment_nonce,
                    uuid: uuid,
                },
                beforeSend: function () {
                    loader.show()
                },
                success: function (response) {
                    location.href = window.location.pathname;
                },
                error: function (error) {
                    loader.hide();
                    console.log(error);
                }
            });
        } catch (error) {
            console.log(error);
            return;
        }
    });

    $(document).on("click", ".funds-validator-open-widget", function (e) {
        e.preventDefault();
        const url = $(this).data("url");
        const win = window.open(url, "popup", "width=1000,height=800");
        const timer = setInterval(function () {
            if (win.closed) {
                loader.show();
                clearInterval(timer);
                window.location.reload();
            }
        }, 500);
    });

    $(document).on("click", ".funds-validator-open-summary", function (e) {
        e.preventDefault();
        const url = $(this).data("url");
        window.open(url, "popup", "width=1000,height=800");
    });

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('id') && urlParams.has('payment_intent') && urlParams.has('redirect_status')) {
        const st = urlParams.get('redirect_status');
        if (st === 'succeeded') {
            const uuid = urlParams.get('id');
            const payment_intent = urlParams.get('payment_intent');
            loader.show();
            stripe_payment_success(uuid, { 'paymentIntent': payment_intent })
        }
    }

    async function stripe_handle_submit(stripe, elements, uuid) {
        loader.show();

        $('div.stripe-form[data-stripe-uuid="' + uuid + '"] .errors').html('');

        stripe.confirmPayment({
            elements,
            confirmParams: {
                // return_url: window.location.href + '?id=' + uuid,
                return_url: window.location.href,
            },
            redirect: "if_required"
        }).then(function (result) {
            if (result.error) {
                loader.hide();
                console.log(result.error)
                $('div.stripe-form[data-stripe-uuid="' + uuid + '"] .errors').html(`<div>${result.error.message}</div>`);
            } else {
                stripe_payment_success(uuid, result);
            }
        });
    }

    function stripe_payment_success(uuid, payment_data) {
        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: {
                action: 'funds_verification_student_payment',
                _ajax_nonce: window.std_data.funds_verification_student_payment_nonce,
                uuid: uuid,
                payment_data: payment_data,
            },
            success: function (response, textStatus, request) {
                const wrp = $('div.stripe-form[data-stripe-uuid="' + uuid + '"]');
                wrp.html('<p>Fee has been paid successfully.</p>');

                location.href = window.location.pathname + '?id=' + uuid;
            },
            error: function (error) {
                loader.hide();
                $(document).find('#stripe-form').html('<p>Something gone wrong! Please try again later.</p>');
                console.log(error);
            }
        });

    }
}